import React, { type ReactNode } from 'react';
import type { FieldType } from '../../../types/EvalancheTypes';
import { Container, CheckboxInput, ErrorMessage, StyledCollectionCheckbox } from '../styles';

export const Checkbox = ({
  field,
  formikProps,
}: {
  field: FieldType;
  formikProps: any;
}): ReactNode => {
  const options = Array.isArray(field.options) ? field.options : Object.values(field.options || {});
  return (
    <Container>
      {field.widget_id === 21 ? (
        <StyledCollectionCheckbox htmlFor={field.name}>
          <CheckboxInput
            type="checkbox"
            id={field.name}
            name={field.name}
            onChange={formikProps.handleChange}
            value="true"
            data-test={`checkbox-${field.name}`}
            hidden={field.hidden}
            readOnly={field.readonly}
          />
          <span>{field.label}</span>
        </StyledCollectionCheckbox>
      ) : (
        options?.map((option) => (
          <StyledCollectionCheckbox htmlFor={option.value} key={option.key}>
            <CheckboxInput
              type="checkbox"
              id={option.value}
              name={field.name}
              onChange={formikProps.handleChange}
              value={option.key}
              data-test={`checkbox-${field.name}`}
              hidden={field.hidden}
              readOnly={field.readonly}
              defaultChecked={
                formikProps.values[field.name] &&
                formikProps.values[field.name].includes(`${option.key}`)
              }
            />
            <span>{option.value}</span>
          </StyledCollectionCheckbox>
        ))
      )}
      {formikProps.errors[field.name] && (
        <ErrorMessage data-test={`checkbox-${field.name}-error`}>
          {formikProps.errors[field.name]}
        </ErrorMessage>
      )}
    </Container>
  );
};
